setTimeout(function () {
  $('.shopify-age-popup').show();
  if (getCookie("advertOnceNew") !== "true") {
    $(".age-verfication-popup").show();
    $('body').addClass('custom_overlay');
  } else {
    $(".age-verfication-popup").hide();
    $('body').removeClass('custom_overlay');
  }
  
  $("#refresh-page").on("click", function () {
    $(".age-verfication-popup").hide();
    $('body').removeClass('custom_overlay');
    setCookie("advertOnceNew", "true", 365);
  });
}, 1500);

// Function to get the value of a cookie
function getCookie(name) {
  var cookieArr = document.cookie.split("; ");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name === cookiePair[0]) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

// Function to set a cookie with expiry
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}